import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../base/button';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import { StyledFormikField, StyledFormikTextArea } from '../base/forms/input';
import { Column, Columns } from '../base/grid';
import { H4 } from '../base/typography';

interface Props {
	isSubmitting: boolean;
}

const InqueryFormFields: FC<Props> = ({ isSubmitting }) => {
	const { t } = useTranslation(['generalForm', 'forms']);
	return (
		<div>
			<H4 marginBottom="2rem" marginTop="2rem">
				{t('forms:info-about-sender')}
			</H4>
			<Columns>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="sender.trackingnumber"
						languageComponent="generalForm"
						label={`${t('trackingnumber')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="sender.trackingnumber"
							name="sender.trackingnumber"
							placeholder={t('trackingnumber')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="sender.affiliate"
						languageComponent="generalForm"
						label={`${t('forms:affiliate')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="sender.affiliate"
							name="sender.affiliate"
							placeholder={t('forms:affiliate')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="sender.address"
						languageComponent="generalForm"
						label={`${t('address')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="sender.address"
							name="sender.address"
							placeholder={t('address')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="sender.zip"
						languageComponent="generalForm"
						label={`${t('zip')}*`}
						smallLabel>
						<StyledFormikField type="text" id="sender.zip" name="sender.zip" placeholder={t('zip')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="sender.email"
						languageComponent="generalForm"
						label={`${t('email')}*`}
						smallLabel>
						<StyledFormikField type="text" id="sender.email" name="sender.email" placeholder={t('email')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="sender.phone"
						languageComponent="generalForm"
						label={`${t('phone')}*`}
						smallLabel>
						<StyledFormikField type="text" id="sender.phone" name="sender.phone" placeholder={t('phone')} />
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<H4 marginBottom="2rem" marginTop="2rem">
				{t('forms:info-about-receiver')}
			</H4>
			<Columns>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.name"
						languageComponent="generalForm"
						label={`${t('name')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.name"
							name="receiver.name"
							placeholder={t('name')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.nameContinue"
						languageComponent="generalForm"
						label={`${t('forms:nameContinue')}`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.nameContinue"
							name="receiver.nameContinue"
							placeholder={t('forms:nameContinue')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.address"
						languageComponent="generalForm"
						label={`${t('address')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.address"
							name="receiver.address"
							placeholder={t('address')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.addressContinue"
						languageComponent="generalForm"
						label={t('forms:addressContinue')}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.addressContinue"
							name="receiver.addressContinue"
							placeholder={t('forms:addressContinue')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.city"
						languageComponent="generalForm"
						label={`${t('city')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.city"
							name="receiver.city"
							placeholder={t('city')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.zip"
						languageComponent="generalForm"
						label={`${t('zip')}*`}
						smallLabel>
						<StyledFormikField type="text" id="receiver.zip" name="receiver.zip" placeholder={t('zip')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.email"
						languageComponent="generalForm"
						label={`${t('email')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.email"
							name="receiver.email"
							placeholder={t('email')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="receiver.phone"
						languageComponent="generalForm"
						label={`${t('phone')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="receiver.phone"
							name="receiver.phone"
							placeholder={t('phone')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<H4 marginBottom="2rem" marginTop="2rem">
				{t('forms:info-about-shipment')}
			</H4>

			<Columns>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="shipmentDetail.packageDescription"
						languageComponent="generalForm"
						label={`${t('forms:packageDescription')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="shipmentDetail.packageDescription"
							name="shipmentDetail.packageDescription"
							placeholder={t('forms:packageDescription')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="shipmentDetail.contents"
						languageComponent="generalForm"
						label={`${t('forms:contents')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="shipmentDetail.contents"
							name="shipmentDetail.contents"
							placeholder={t('forms:contents')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="shipmentDetail.contentsValue"
						languageComponent="generalForm"
						label={`${t('forms:contentsValue')}*`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="shipmentDetail.contentsValue"
							name="shipmentDetail.contentsValue"
							placeholder={t('forms:contentsValue')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<Columns>
				<Column>
					<FormikFieldWrapper
						name="comments"
						label={t('forms:comments')}
						smallLabel
						languageComponent="generalForm">
						<StyledFormikTextArea
							type="text"
							component="textarea"
							id="comments"
							name="comments"
							padding="1rem"
							placeholder={t('forms:comments-more')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<Columns>
				<Column>
					<Button wide primary type="submit" isLoading={isSubmitting}>
						{t('submit')}
					</Button>
				</Column>
			</Columns>
		</div>
	);
};

export default InqueryFormFields;
